import { put, call, select } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';

import * as Api from 'api';
import * as Actions from 'actions';
import * as ActionTypes from 'constants';

/***************************** Selectors ************************************/

/***************************** Subroutines ************************************/
function * savePipeline(action) {
  const { _id } = action.payload.pipeline || {};

  if(_id) {
    yield put(Actions.sendSocketEmit(action.payload, 'update-pipeline'));
  }
  else {
    yield put(Actions.sendSocketEmit(action.payload, 'create-pipeline'));
  }
}
function * savePipelineFailed(action) {
  yield put(Actions.notify(action.payload));
}
function * fetchPipeline(action) {
  try {
    const pipeline = yield call(Api.fetchPipeline);
    yield put({
      type : ActionTypes.FETCH_PIPELINE_SUCCESS,
      payload : { pipeline }
    })
  }
  catch(error) {
    yield put({
      type : ActionTypes.FETCH_PIPELINE_FAILED,
      payload : error,
    });
  }
}
/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/
export function * pipelineWatcher() {
  yield * [
    takeEvery(ActionTypes.SAVE_PIPELINE, savePipeline),
    takeEvery(ActionTypes.FETCH_PIPELINE, fetchPipeline),
    takeEvery(ActionTypes.UPDATE_PIPELINE_FAILED, savePipelineFailed),
    takeEvery(ActionTypes.CREATE_PIPELINE_FAILED, savePipelineFailed),
  ]
}



// WEBPACK FOOTER //
// ./src/common/sagas/pipeline.js